import Link from "next/link";
import React from "react";

const CtaSection = ({ industryData }) => {
  return (
    <section className="cta-section gradient-cta-section industry-cta-section">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-12 col-md-12 col-sm-12">
            <div className="cta-inner">
              <div className="cta-details">
                <span
                  itemProp="heading"
                  dangerouslySetInnerHTML={{
                    __html: industryData?.value?.title,
                  }}
                ></span>
                <p
                  itemProp="description"
                  dangerouslySetInnerHTML={{
                    __html: industryData?.value?.description,
                  }}
                ></p>
              </div>
              <div className="cta-request-btn">
                <Link
                  href={industryData?.value?.card_link?.url}
                  itemProp="link"
                  className="card-link"
                >
                  <span className="card-link-text">
                    {industryData?.value?.card_link_text}
                  </span>
                  <span className="arrow-down"></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
